export const LT_MONTHS = [
  "sausio",
  "vasario",
  "kovo",
  "balandžio",
  "gegužės",
  "birželio",
  "liepos",
  "rugpjūčio",
  "rugsėjo",
  "spalio",
  "lapkričio",
  "gruodžio",
];

export const formatDateLt = (date: Date) => {
  const year = date.getFullYear();
  const month = LT_MONTHS[date.getMonth()];
  const day = date.getDate();
  return `${year} m. ${month} ${day} d.`;
};

export const getCurrentDateLt = () => formatDateLt(new Date());
